export default {
    fieldMappingContainer: {
        width: "100%", 
        display: "flex", 
        flexDirection: "row", 
        gap: "50px",
    },
    formFieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "3px",
    },
    draggableCardStyle: {
        width: '18rem',
        height: "60px",
        cursor: "grab",
    },
    cardContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
    },
    mappedCardDiv:{
        position: "relative",
    },
    droppedCardDiv: {
        boxShadow: "0px 4px 8px rgba(33, 93, 170, 0.4)",
    },
    mappedBox:{
        opacity: 0.4,
    },
    removeBox: {
        position: "absolute",
        top: "-15px",
        right: "-15px",
    },
    thirdPartyFieldsSection: {
        display: "flex",
        flexDirection: "column",
    },
    columnHeadingsRow: {
        display: "flex",
        flexDirection: "row",
    },
    thirdPartyFieldGroup: {
        display: "flex",
        flexDirection: "row",
    },
    thirdPartyFieldCardContainer: {
        width: '18rem',
        height: "70px",
        background: "#FFFFFF", 
        border: "1px solid #efeaea",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "10px",
    },
    thirdPartyFieldDropCardContainer: {
        width: '18rem',
        height: "70px",
        background: "#FFFFFF", 
        border: "1px solid #efeaea",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    thirdPartyWhiteContainer: {
        borderRadius: "6px",
    },
    dropableAreaCard: {
        width: '18rem',
        height: "70px",
        background: "#FFFFFF",
    },
    excelColumnHeading: {
        width: '18rem',
    },
}